import { takeLatest, put, call, SagaReturnType } from 'redux-saga/effects';
import { laborHoursConstant } from 'src/redux/actions/constant';
import laborHoursService from 'src/services/apiServices/laborHoursService/laborHoursService';

function* getPayPeriodByDate(action: any): SagaReturnType<any> {
  try {
    yield put({ type: laborHoursConstant.GET_PAY_PERIOD_BY_DATE_LOADER });
    const response = yield call(laborHoursService.getPayPeriodByDate, action.payload);
    if (response?.status === 200) {
      yield put({
        type: laborHoursConstant.GET_PAY_PERIOD_BY_DATE_SUCCESS,
        payload: response.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: laborHoursConstant.GET_PAY_PERIOD_BY_DATE_FAILURE, payload: error });
  }
}

function* getPayPeriodByDateSaga() {
  // takeLatest — a quick run through the calendar must not leave an older day's cycle on screen.
  yield takeLatest(laborHoursConstant.GET_PAY_PERIOD_BY_DATE_REQUEST, getPayPeriodByDate);
}

export default getPayPeriodByDateSaga;
